import { componentInterface as stubImplementation } from '@ardoq/component-interface';
// eslint-disable-next-line no-restricted-imports
import { componentInterface } from './componentInterface';

export const initializeComponentInterface = () => {
  stubImplementation.registerImplementation(componentInterface);
};
